














































































import { defineComponent, computed, ref } from '@vue/composition-api';
import { OfficialUser } from '@/admin/officialUsers';
import officialUsers from '@/composition/officialUser';
import { useNotification } from '@/composition/notification';
import FcImage from '@/components/FcImage.vue';
import FcColor from '@/components/FcColor.vue';
import FcStaticImage from '@/components/FcStaticImage.vue';
import myAttributes from '@/composition/myAttributes';
import FcRoleLoading from '@/components/FcRoleLoading.vue';

export default defineComponent({
  name: 'OfficialUsers',
  components: {
    FcImage,
    FcColor,
    FcStaticImage,
    FcRoleLoading,
  },
  props: {
    prevPage: {
      type: String,
      required: false,
    },
  },
  setup() {
    const myRoleSettings = computed(() => myAttributes.getRoleSettings('officialusers'));

    const notification = useNotification();

    const items = computed(() => officialUsers.officialUsers);
    const officialUserId = ref('');
    const name = ref('');
    const icon = ref('');
    const color = ref('');
    const active = ref(false);
    const isSaving = ref(false);

    const open = (item?: OfficialUser) => {
      if (item) {
        name.value = item.name;
        color.value = item.color;
        icon.value = item.icon;
        officialUserId.value = item.officialUserId;
      }
      active.value = true;
    };

    const cancel = () => {
      name.value = '';
      color.value = '';
      icon.value = '';
      officialUserId.value = '';
      active.value = false;
    };

    //現段階で未実装
    const save = async () => {
      if (!name.value || !icon.value || !color.value) {
        alert('未入力があります。');
        return;
      }
      const props = {
        name: name.value,
        icon: icon.value,
        color: color.value,
      };
      isSaving.value = true;
      try {
        if (officialUserId.value) await officialUsers.editOfficialUser(props, officialUserId.value);
        else await officialUsers.createOfficialUser(props);
        await officialUsers.getOfficialUsers();
        notification.notify(`${officialUserId.value ? '更新しました。' : '作成しました。'}`);
      } catch (error) {
        notification.error(error);
      }
      cancel();
      isSaving.value = false;
    };

    const headers = [
      { text: '名前', value: 'name' },
      { text: 'アイコン', value: 'icon' },
      { text: 'カラー', value: 'color' },
    ];

    return {
      pageTitle: '公式ユーザー',
      myRoleSettings,
      items,
      name,
      icon,
      color,
      active,
      open,
      cancel,
      save,
      headers,
      isSaving,
      officialUsers,
    };
  },
});
